import React, { CSSProperties, useEffect, useState } from 'react';

import { AdCampaign } from '../models/AdCampaign';
import { useProgram } from '../utils/ProgramContext'

const styles: { [key: string]: CSSProperties } = {
    list: {
        padding: 0,
        listStyleType: 'none',
    },
    listItem: {
        margin: '10px 0',
        padding: '15px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
    },
    name: {
        fontWeight: 'bold',
        marginBottom: '10px',
    },
    checkbox: {
        marginRight: '10px',
    },
};


const AdList: React.FC = () => {
    const [ads, setAds] = useState<AdCampaign[]>([])
    const { program } = useProgram() || {}

    useEffect(() => {
        async function getAccounts() {
            if (!program) {
                return 
            }
            const accounts = await program.account.adCampaign.all()
            if (accounts?.length == 0) {
                return
            }
            const res = []
            for (const account of accounts) {
                if (account) {
                    res.push(new AdCampaign(account.account.id as number, account.account.name as string, account.account.link as string, account.publicKey))
                }
            }
            setAds(res)
        }
        getAccounts()

    }, [program])

    return (
        <div className="screen-provider-list">
            <h2>Ads</h2>
            <ul style={styles.list}>
                {ads.map((ad: AdCampaign, index) => (
                    <li key={index} style={styles.listItem}>
                        <div style={styles.name}>Name: {ad.name}</div>
                        <div style={styles.name}>PubKey: {ad.publicKey?.toString()}</div>
                        <img src={ad.link} style={{ maxHeight: "150px" }} />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default AdList;
